import React, { useEffect, useState } from "react";
import { Checkbox, Modal } from "antd";

const ExportColumnsModal = ({
  open,
  title = "Export PDF",
  columnOptions = [],
  onCancel,
  onExport,
}) => {
  const [selectedKeys, setSelectedKeys] = useState([]);

  useEffect(() => {
    if (open) {
      setSelectedKeys(
        columnOptions
          .filter((option) => option.selected !== false)
          .map((option) => option.key),
      );
    }
  }, [open, columnOptions]);

  const handleExport = () => {
    onExport(
      columnOptions
        .map((option) => option.key)
        .filter((key) => selectedKeys.includes(key)),
    );
  };

  return (
    <Modal
      title={title}
      open={open}
      onOk={handleExport}
      onCancel={onCancel}
      okText="Export"
      okButtonProps={{ disabled: selectedKeys.length === 0 }}
      destroyOnClose
    >
      <p className="text-gray-500 text-sm mb-3">
        Select the columns to include in the PDF.
      </p>
      <Checkbox.Group
        value={selectedKeys}
        onChange={setSelectedKeys}
        className="flex flex-col gap-2"
      >
        {columnOptions.map((option) => (
          <Checkbox key={option.key} value={option.key}>
            {option.label}
          </Checkbox>
        ))}
      </Checkbox.Group>
    </Modal>
  );
};

export default ExportColumnsModal;
